import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});
export const styles = StyleSheet.create({
  title: {
    color: '#27343d',
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 400,

    paddingLeft: 53,
    paddingBottom: 20,
  },

  multiTouchPointWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    paddingLeft: 53,
    paddingRight: 53,
    width: '100%',
    flexWrap: 'wrap',
  },
  multiTouchPointItem: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#EEEEEE',
    borderRadius: '4px',
    width: '100%',
  },
  imageWrapper: {
    width: '100%',
    height: '111px',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    alignSelf: 'flex-start',
    padding: '12px',
    width: '100%',
  },
  itemTitle: {
    breakWord: 'word-break',
    color: 'black',
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 900,
  },
  itemSubtitle: {
    breakWord: 'word-break',
    color: 'black',
    fontSize: 9,
    fontFamily: 'Lato',
    lineHeight: 1.5,
  },
});
